import React, { useState, useEffect } from "react";
import { ShoppingCart, Check } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const GOLD = "#DBAE6E";

const OptionSelector = ({ label, options, selected, setSelected }) => (
  <>
    <p className="mb-4 text-lg font-semibold text-black dark:text-white tracking-wide">Select {label}</p>
    <div className="flex flex-wrap gap-2 justify-center">
      {options.map((opt) => (
        <button
          key={opt}
          className={`px-3 py-1 rounded-md border text-sm font-medium transition-all ${
            selected === opt
              ? "bg-[#DBAE6E] text-black dark:text-white border-[#DBAE6E] shadow-md"
              : "bg-transparent text-black dark:text-secondary border-gray-600 hover:border-[#DBAE6E] hover:text-[#DBAE6E]"
          }`}
          onClick={() => setSelected(opt)}
        >
          {opt}
        </button>
      ))}
    </div>
  </>
);

const ProductCard = ({ product, setSelectedProduct, addingToCart, setAddingToCart, handleAddToCart }) => {
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);

  useEffect(() => {
    if (selectedSize && selectedColor) {
      setTimeout(() => {
        handleAddToCart(product, selectedSize, selectedColor);
        setAddingToCart(null);
        setSelectedSize(null);
        setSelectedColor(null);
      }, 1000);
    }
  }, [selectedSize, selectedColor]);



  return (
    <AnimatePresence mode="wait">
      {addingToCart === product.id ? (
        <motion.div
          key={`adding-${product.id}`}
          className="bg-primary dark:bg-primary-dark text-white dark:text-white shadow-lg w-50 h-[360px] flex flex-col justify-center items-center p-6 rounded-xl border border-[#333]"
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          {!selectedSize ? (
            <OptionSelector label="Size" options={product.sizes} selected={selectedSize} setSelected={setSelectedSize} />
          ) : !selectedColor ? (
            <OptionSelector label="Color" options={product.colors} selected={selectedColor} setSelected={setSelectedColor} />
          ) : (
            <motion.div 
              className="flex flex-col items-center" 
              initial={{ scale: 0.5, opacity: 0 }} 
              animate={{ scale: 1, opacity: 1 }} 
              transition={{ duration: 0.5 }}
            >
              <motion.div 
                className="bg-green-500 p-4 rounded-full shadow-lg" 
                initial={{ scale: 0 }} 
                animate={{ scale: 1.2 }} 
                transition={{ type: "spring", stiffness: 150 }}
              >
                <Check size={48} className="text-primary-text dark:primary-text-dark" />
              </motion.div>
              <p className="mt-4 text-xl font-medium text-primary-text dark:primary-text-dark">Added!</p>
            </motion.div>
          )}
        </motion.div>
      ) : (
        <motion.div
          key={`card-${product.id}`}
          className="bg-primary dark:bg-primary-dark rounded-xl shadow-lg w-50 h-[300px] flex flex-col overflow-hidden  hover:shadow-xl transition-all duration-300"
          initial="hidden"
          animate="visible"
          exit="exit"
          whileHover={{ scale: 1.03, boxShadow: `0 0 15px rgba(219, 174, 110, 0.3)` }}
          onClick={() => setSelectedProduct(product)}
        >
          <div className="h-56 w-full overflow-hidden">
            <img
              src={product.images[product.colors[0]][0]}
              alt={product.name}
              className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="p-2 flex flex-col flex-grow justify-between">
            <h3 className="text-black dark:text-white text-sm mb-2">{product.name}</h3>
            <div className="flex items-baseline space-x-2">
              <p className="text-lg font-bold" style={{ color: GOLD }}>₹{(product.price * (1 - product.discount)).toFixed(2)}</p>
              {product.discount > 0 && <p className="text-sm text-primary-text dark:primary-text-dark line-through">₹{product.price.toFixed(2)}</p>}
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                setAddingToCart(product.id);
              }}
              className="w-full mt-4 py-2 rounded-md flex items-center justify-center gap-2 font-semibold shadow-md hover:bg-opacity-90 transition-all"
              style={{ backgroundColor: GOLD, color: "#000" }}
            >
              <ShoppingCart size={20} />
              Add to Cart
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ProductCard;